'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCardShortName = exports.getCompareLink = exports.getCards = exports.getSubTitle = exports.getTitle = exports.getShowLessButtonLabel = exports.getShowMoreButtonLabel = exports.getCompareButtonLabel = exports.getQeId = exports.getCompareCards = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _getCardImage2 = require('acq-components/lib/utils/getCardImage');

var _getCardImage3 = _interopRequireDefault(_getCardImage2);

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _misc = require('acq-utils/lib/misc');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCompareCards = exports.getCompareCards = function getCompareCards(state) {
  return (0, _lodash2.default)(state.intlPage, 'page.compareCards');
};

var getCompareDataLinks = (0, _reselect.createSelector)(getCompareCards, function (compareData) {
  return (0, _lodash2.default)(compareData, 'links') || [];
});

var getQeId = exports.getQeId = (0, _reselect.createSelector)(getCompareCards, function (compareData) {
  return (0, _lodash2.default)(compareData, 'qeId') || undefined;
});

var getCompareDataLink = function getCompareDataLink(keyStr) {
  return (0, _reselect.createSelector)(getCompareDataLinks, function (links) {
    return (links || []).find(function (link) {
      return (0, _lodash2.default)(link, 'key') === keyStr;
    });
  });
};

var getCompareDataLinkText = function getCompareDataLinkText(keyStr) {
  return (0, _reselect.createSelector)(getCompareDataLink(keyStr), function (link) {
    return (link || {}).title || '';
  });
};

var getButtonTitle = function getButtonTitle(keyStr) {
  return (0, _reselect.createSelector)((0, _common.getLinkSelector)(keyStr), function (link) {
    return (0, _lodash2.default)(link, 'title') || '';
  });
};

var getCompareButtonLabel = exports.getCompareButtonLabel = getCompareDataLinkText('compareTable');

var getShowMoreButtonLabel = exports.getShowMoreButtonLabel = getCompareDataLinkText('showMore');

var getShowLessButtonLabel = exports.getShowLessButtonLabel = getCompareDataLinkText('showLess');

var getTitle = exports.getTitle = (0, _reselect.createSelector)(getCompareCards, function (compareCards) {
  return (0, _lodash2.default)(compareCards, 'header') || '';
});

var getSubTitle = exports.getSubTitle = (0, _reselect.createSelector)(getCompareCards, function (compareCards) {
  return (0, _lodash2.default)(compareCards, 'subTitle') || '';
});

var byText = function byText(d) {
  return d.text;
};
var joinDesc = function joinDesc(desc) {
  return (desc || []).filter(byText).map(byText).join(' ');
};

var cell = function cell(_ref) {
  var _ref$imageUrl = _ref.imageUrl,
      imageUrl = _ref$imageUrl === undefined ? '' : _ref$imageUrl,
      _ref$imageAlt = _ref.imageAlt,
      imageAlt = _ref$imageAlt === undefined ? '' : _ref$imageAlt,
      _ref$header = _ref.header,
      header = _ref$header === undefined ? '' : _ref$header,
      _ref$description = _ref.description,
      description = _ref$description === undefined ? '' : _ref$description;
  return {
    imageUrl: imageUrl,
    imageAlt: imageAlt,
    components: {
      header: header,
      description: description
    }
  };
};

var buildCardLinkForMiniCompare = function buildCardLinkForMiniCompare(url) {
  var dtmInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var card = arguments[2];
  return (0, _misc.appendQueryParams)(url, {
    linknav: dtmInfo.linkNavBase + '-' + dtmInfo.pageName + '-' + _dtmConsts.DTM_CONSTS.compare + '-' + card.dtmProductName
  });
};

var parseMiniCompareCards = function parseMiniCompareCards(cardData, compareData, dtmInfo) {
  var cards = (0, _lodash2.default)(cardData, 'compareCards') || [];
  var labels = (0, _lodash2.default)(compareData, 'order') || [];

  return cards.map(function (card) {
    var learnMore = ((0, _lodash2.default)(card, 'links') || []).find(function (link) {
      return link.key === 'learnMore';
    });
    var cardUrl = learnMore ? buildCardLinkForMiniCompare(learnMore.url, dtmInfo, card) : '';

    var _getCardImage = (0, _getCardImage3.default)(card, 'tile'),
        imageUrl = _getCardImage.url,
        imageAlt = _getCardImage.alt;

    var firstCell = [{
      imageUrl: imageUrl,
      imageAlt: imageAlt,
      header: (0, _lodash2.default)(card, 'cardTitle')
    }];

    var otherCells = labels.map(function (label) {
      var currentFeature = ((0, _lodash2.default)(card, 'cardFeatures.content') || []).find(function (cardFeature) {
        return cardFeature.key === label;
      });
      var description = joinDesc((0, _lodash2.default)(currentFeature, 'desc'));
      return {
        imageUrl: '',
        header: (0, _lodash2.default)(currentFeature, 'header'),
        description: description
      };
    });

    var rows = [].concat(firstCell, (0, _toConsumableArray3.default)(otherCells)).map(cell);

    return { rows: rows, cardUrl: cardUrl };
  });
};

var getCards = exports.getCards = (0, _reselect.createSelector)([_common.getCardData, getCompareCards, _common.dtmSelector], parseMiniCompareCards);

var getCompareLink = exports.getCompareLink = (0, _reselect.createSelector)(getCompareCards, function (compareCards) {
  return compareCards && (compareCards.links || []).find(function (l) {
    return l.key === 'compareTable';
  });
});

var getCardShortName = exports.getCardShortName = (0, _reselect.createSelector)(_common.getCardData, function (card) {
  return (0, _lodash2.default)(card, 'shortName') || '';
});